import React from 'react'

export const l10nContext = React.createContext('fi')

export const withLocale = Component => {
    return function ComponentWithLocale(props) {
        return <l10nContext.Consumer>{locale => <Component {...props} locale={locale} />}</l10nContext.Consumer>
    }
}
